import { regexNumber } from './regex';

export const removeSpaces = (value: string | number) => value.toString().replace(/\s/g, '');

interface PrettyNumberSettings {
  postfix?: string | number;
  prefix?: string | number;
  decimals?: number;
}

const formatDecimals = (value: number, decimals: number) => {
  if (!decimals) return value;
  const upper = Math.pow(10, decimals);
  return (Math.round(value * upper) / upper).toFixed(decimals);
};

export const prettyNumber = (value: number | undefined, settings?: PrettyNumberSettings) => {
  if (value === undefined) return '???';
  const formattedValue = formatDecimals(
    value,
    settings?.decimals !== undefined ? settings.decimals : 0
  );
  return `${settings?.prefix ? `${settings.prefix}` : ''}${removeSpaces(formattedValue).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ' '
  )}${settings?.postfix ? ` ${settings.postfix}` : ''}`;
};

export const onlyNumbers = (value: string) => value.replace(regexNumber, '');

export const roundValue = (value: number | undefined) => {
  if (value === undefined) return undefined;
  return Math.round(value / 100) * 100;
};
